import { useState } from "react";
import { PiSirenBold } from "react-icons/pi";
import { IoCloseSharp } from "react-icons/io5";

const ScamAlertPopup = () => {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div className="fixed bottom-6 right-1 md:right-6 z-50 max-w-xl w-full">
      <div className="relative bg-[#FFF3E0] border-[1px] border-[#FF9800] p-4 shadow-xl rounded-lg">
        {/* Close Button */}
        <button
          onClick={() => setVisible(false)}
          className="absolute -top-3 -right-3 text-xl text-black bg-[#FFF3E0] p-1 border border-[#FF9800] rounded-full"
        >
          <IoCloseSharp size={16} color="#000000" />
        </button>

        <div className="w-full flex items-start gap-2">
          <div className="pt-1">
            <PiSirenBold size={24} color="#FF9800" />
          </div>

          <div className="w-full">
            <h2 className="text-lg font-RobotoBold text-red-600 mb-2">
              <span className="ml-1">Scam Alert – Important Notice</span>
            </h2>

            <p className="text-black font-RobotoRegular text-sm mb-2">
              It has come to our attention that unauthorized individuals or
              websites are falsely claiming to represent our company and
              soliciting investments, such as asking people to invest ₹21,000 or
              other amounts.{" "}
              <b>
                Please be advised that these claims are fraudulent and are in no
                way associated with our company.
              </b>
            </p>

            <p className="text-black text-sm mb-2">
              <span className="text-red-600 font-RobotoBold">
                We are not in the business of offering any type of investment
                opportunity.
              </span>
              <br />
              Do not trust or engage with any person, platform, or website
              requesting money on our behalf.
            </p>

            <p className="text-black font-RobotoRegular text-sm ">
              We strongly urge the public to:
            </p>

            <ul className="list-disc list-inside font-RobotoRegular text-black text-sm mb-2">
              <li>Verify any communication claiming to be from us.</li>
              <li>
                Never transfer money or personal information based on unofficial
                or unverified sources.
              </li>
              <li>
                Report suspicious activity to the appropriate authorities
                immediately.
              </li>
            </ul>

            <p className="text-black font-RobotoRegular text-sm">
              Your safety and trust are important to us. For any queries, please
              contact us through the official contact details listed on this
              website.
              <br />
              <b>Stay alert.</b>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScamAlertPopup;
